
const PersonListModel = function (){
    const name = 'PersonList';
    return {
        name,
        state:{
            condition:{
                name:'',
                mobile:'',
                status:'',
            },
            newModal:{
                id:'',
                name:'',
                mobile:'',
                email:'',
                password:'',
                con_password:'',
                permission:'',
                roleId:'',
                sex:'',
                qq:'',
                weibo:'',
                wechat:'',
                idCode:'',
                idType:'',
            },
            list:[],
            page:{
                pageSize:30,
                current:1,
                total:0,
            }
        },
        selectors:(state, props) => {
            const currentState = state[name];
            const selectors = {
                getCondition:()=>currentState.condition,
                getNewModalData:()=>currentState.newModal,
                getList:()=>currentState.list,
                getPage:()=>currentState.page,
            };
            return selectors;
        },
        api:{},
        actions:{
            changeCondition:(key,value) => (dispatch,getState) => {
                dispatch({
                    type:'CHANGE_PERSONLISTCONDITION',
                    key,
                    value
                })
            },
            changeNewModalData:(key,value) => (dispatch,getState) => {
                dispatch({
                    type:'CHANGE_PERSONLISTNEW_MODAL',
                    key,
                    value
                })
            },
            changeList:(list) => (dispatch,getState) => {
                dispatch({
                    type:'CHANGE_PERSONLISTLIST',
                    list
                })
            },
            changePage:(page) => (dispatch,getState) => {
                dispatch({
                    type:'CHANGE_PERSONLISTPAGE',
                    page
                })
            }
        },
        reducers:{
            condition:(state = PersonListModel.state.condition, action) => {
                if(action.type === 'CHANGE_PERSONLISTCONDITION'){
                    const { key, value } = action;
                    const obj = {};
                    obj[key] = value;
                    return Object.assign({}, state, obj);
                }
                return state;
            },
            newModal:(state = PersonListModel.state.newModal, action) => {
                if(action.type === 'CHANGE_PERSONLISTNEW_MODAL'){
                    const { key, value } = action;
                    const obj = {};
                    obj[key] = value;
                    return Object.assign({}, state, obj);
                }
                return state;
            },
            page:(state = PersonListModel.state.page, action) => {
                if(action.type === 'CHANGE_PERSONLISTPAGE'){
                    return Object.assign({}, state, action.page );
                }
                return state;
            },
            list:(state = PersonListModel.state.list , action ) => {
                if(action.type === 'CHANGE_PERSONLISTLIST'){
                    return [ ...action.list ];
                };
                return state;
            }
        }
    }
}();

export default PersonListModel;


// WEBPACK FOOTER //
// ./src/models/PersonListModel.js